import React from 'react';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Heading from '@amzn/meridian/heading';
import Box from '@amzn/meridian/box';
import { FormattedMessage } from 'react-intl';

const GrowModelActions: React.FC = (): React.ReactElement => {
  return (
    <Row type='outline' spacingInset='500 400'>
      <Column alignmentVertical='top'>
        <Text type='d50'>02</Text>
      </Column>
      <Box>
        <Column>
          <Heading level={4}>
            <FormattedMessage
              id='cs_perfportal_coaching_form_grow_model_sayLessAskMore'
              defaultMessage='Say Less, Ask More'
            />
          </Heading>
          <Text type='b300'>
            <FormattedMessage
              id='cs_perfportal_coaching_form_grow_sayLessAskMore_subtitle'
              defaultMessage='Use open-ended questions throughout the conversation and avoid the “advice monster”'
            />
          </Text>
          <Row widths={['50%', '50%']}>
            <Column>
              <Text type='h100'>
                <FormattedMessage
                  id='cs_perfportal_coaching_form_grow_modeel_embraceSilence'
                  defaultMessage='Embrace silence'
                />
              </Text>

              <Text type='h100'>
                <FormattedMessage
                  id='cs_perfportal_coaching_form_grow_model_straightForward'
                  defaultMessage='Be straightforward'
                />
              </Text>
            </Column>
            <Column>
              <Text type='h100'>
                <FormattedMessage
                  id='cs_perfportal_coaching_form_grow_model_beEngaging'
                  defaultMessage='Be engaging'
                />
              </Text>

              <Text type='h100'>
                <FormattedMessage
                  id='cs_perfportal_coaching_form_grow_model_beConsistent'
                  defaultMessage='Be consistent'
                />
              </Text>
            </Column>
          </Row>
        </Column>
      </Box>
    </Row>
  );
};

export default GrowModelActions;
